<template>
  <div>
    <v-card>
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        show-select
        v-model="selectedItemList"
        :footer-props="{
          'items-per-page-options': [10, 15, 20, 50, 100, 250]
        }"
        :height="windowHeight"
        fixed-header
        single-select
    >
      <template v-slot:top>
        <v-toolbar flat class="mt-4" ref="RefListTop">
          <v-text-field
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-switch v-model="isAlive" label="not alive/alive" class="ml-5 mt-4"
                    @change="onUpdateSearchTerm"></v-switch>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" :loading="loading" @click="newEmptyRow">
            New
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.search_status="{ item }">
        <v-btn
            @click="onSearch(item)"
            :loading="action_loading"
            color="primary"
            icon
            text
            dark
        >
          <v-icon color="statusColor">mdi-card-search-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.mpn="{ item }">
        <v-text-field
            class="mt-1 mb-n5 text-caption"
            dense
            outlined
            v-model="item.mpn"
            type="text"
            @change="onFieldChange(item, 'mpn')"
        >
        </v-text-field>
      </template>

      <template v-slot:item.available_providers="{ item }">
        <v-checkbox v-for="row in item.available_providers" :key="row.slug"
          v-model="item.selected_providers"
          :label="row.name"
          :value="row.slug"
          @change="onFieldChange(item, 'selected_providers')"
        ></v-checkbox>
      </template>

      <template v-slot:item.correct_status="{ item }">
        <v-radio-group
            v-model="item.correct_status"
            @change="onFieldChange(item, 'correct_status')"
        >
          <v-radio
            v-for="status in ['OK', 'NOK', 'Fixed']"
            :key="status"
            :label="status"
            :value="status"
          ></v-radio>
    </v-radio-group>
      </template>

    </v-data-table>

    <v-card-actions flat dense ref="RefListFooter">
        <BaseDeleteDialog v-if="isAlive" :disabled="!(selectedItemList.length > 0)" :loading="deleteLoading"
                          :onDeleteAction="onRemoveItems" title="Remove selected"></BaseDeleteDialog>
        <v-btn
            color="primary"
            class="mx-4"
            @click="onRestore"
            :loading="restoring"
            :disabled="!(selectedItemList.length > 0)"
            v-if="!isAlive"
        >
          Restore selected
        </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
      <v-footer dark padless color="error" v-if="message_error">
        <span class="pl-5"> Error: {{ message_error }} </span>
      </v-footer>
    </v-card>
    <router-view></router-view>
  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress"
// import MPNResearchItemV2 from "@/components/MPNResearchV2/MPNResearchItemV2";
// import MPNResearchDialog from "@/components/MPNResearch/MPNResearchDialog";


export default {
  name: 'MPNChecking',
  props: {
    subtractHeight: {type: [Number], default: 150},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {
    BaseDeleteDialog,
    BaseTaskProgress,
  },

  computed: {
    ...mapGetters('MPNChecking', ['getColumns']),
    ...mapFields('MPNChecking', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading']),
  },

  methods: {
    ...mapActions('MPNChecking', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
          'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
          'fetchActionSelectedItem', 'fetchActionItem']),
    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      console.log(this.$refs)
      let topHeight = 10
      if (this.$refs.RefListTop)
        topHeight = this.$refs.RefListTop.$el.clientHeight
      let footerHeight = 10
      if (this.$refs.RefListFooter)
        footerHeight = this.$refs.RefListFooter.clientHeight
      this.windowHeight = (window.innerHeight - this.subtractHeight - topHeight - footerHeight) + "px"
      console.log('this.windowHeight', this.windowHeight)
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.fetchItemList()
    }, 800),

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },

    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
    onSyncNotion() {
      // console.log('onSyncNotion')
      this.fetchSyncNotionSelectedItems();
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
    onFieldChange(item, fieldName) {
      // console.log('onFieldChange', item, fieldName)
      let fields_dict = {}
      fields_dict[fieldName] = item[fieldName]
      fields_dict['version'] = item['version']
      this.fetchSaveItemField({
        itemId: item.id,
        fields_dict: fields_dict,
      })
    },
    deniedEdit(item) {
      return !(item.task_status === false ||
          item.task_status === true ||
          item.task_id === null)
    },
    newEmptyRow() {
      let newItem = {
        id: null,
      }
      this.itemList.unshift(newItem)
    },
    statusColor() {
      if(this.search_status === 'OK')
        return 'success'
      if(this.search_status === 'NOK')
        return 'error'
      return 'primary'
    },
    onSearch(item) {
      let params = {
        action_name: 'checking',
        parameters: null,
        id_list: [item.id],
      }
      this.fetchActionItem(params);
    }
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
    this.onResize()
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
    }
  }
}
</script>

<style scoped lang="scss">

</style>
